import { __assign } from "tslib";
import React from 'react';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import noop from '../../../utils/noop';
var UserCoreBadge = function (_a) {
    var corePackage = _a.corePackage, size = _a.size, biData = _a.biData, className = _a.className, _b = _a.openUserSymbolPopup, openUserSymbolPopup = _b === void 0 ? false : _b, _c = _a.pushUserSymbolsPopup, pushUserSymbolsPopup = _c === void 0 ? noop : _c;
    if (openUserSymbolPopup) {
        var biEventData = __assign(__assign({}, biData), { symbol: corePackage, evid: BiEventType.USER_SYMBOL_CLICK });
        var spanProps = {
            className: className,
        };
        var onClick = function (ev) {
            ev.preventDefault();
            // Only open the popup if we're not in an iframe
            if (window.self === window.top) {
                pushUserSymbolsPopup();
            }
        };
        return (React.createElement(BiSpan, __assign({}, spanProps, { 
            // Role = "img" here to allow aria-label to exist on
            // this element without lighthouse throwing a fit
            role: "img", biData: biEventData, onClick: onClick, stopPropagation: true }),
            React.createElement(CoreBadge, { corePackage: corePackage, size: size, className: className })));
    }
    return (React.createElement(CoreBadge, { corePackage: corePackage, size: size, className: className }));
};
UserCoreBadge.displayName = 'UserCoreBadge';
export default UserCoreBadge;
//# sourceMappingURL=UserCoreBadge.js.map